import { useState, useEffect } from 'react';

/**
 * Custom hook to check if there's navigation history available
 * This helps determine whether to show a back button or not
 */
export const useNavigationHistory = () => {
  const [canGoBack, setCanGoBack] = useState(false);

  useEffect(() => {
    // Check if there's history to go back to
    // This checks if the user navigated here from another page within the app
    const hasHistory = window.history.length > 1;
    const hasReferrer = document.referrer && 
                       document.referrer !== window.location.href &&
                       document.referrer.includes(window.location.origin);
    
    // Set canGoBack to true if there's either browser history or a valid referrer from same origin
    setCanGoBack(hasHistory && hasReferrer);
  }, []);

  return canGoBack;
};

export default useNavigationHistory;